import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { RENDERABLE } from '../Utils/propTypes';
import './style.scss';

const Footer = ({ children, buttonText, onClick, isButtonDisabled }) => {
    const classes = classNames('modal-popup-footer', 'font-accent', { 'with-text': children });

    return (
        <footer className={classes}>
            {children && <div>{children}</div>}
            <Button onClick={onClick} disabled={isButtonDisabled}>{buttonText}</Button>
        </footer>
    );
};

Footer.propTypes = {
    children: RENDERABLE,
    buttonText: PropTypes.string,
    onClick: PropTypes.func,
    isButtonDisabled: PropTypes.bool
};

Footer.defaultProps = {
    isButtonDisabled: false
};

export default Footer;
